module.exports = __webpack_public_path__ + "img/dis1.9de77065.png";